<template>
  <div class="w-full h-full">
    <departure-selection background-color="bg-yellow-brand"></departure-selection>
    <div v-if="priceGbp && priceUsd">
      <p class="mb-5 pl-2.5 pt-2.5 label">Price</p>
      <p class="mb-2.5 text-center label">From</p>
      <p class="mb-5 text-center font-primary font-extrabold text-blue-dark text-28 leading-1">
        <display-price :price-gbp="priceGbp" :price-usd="priceUsd"></display-price>
      </p>
    </div>
    <div class="relative p-5">
      <a href="/contact" class="block triggertheblock button w-full mb-2.5 mx-auto">
        Enquire now
      </a>
      <button
        @click.prevent="bookNow"
        v-if="!enquireOnly"
        class="block button w-full enquiryform mx-auto bg-yellow-brand hover:bg-yellow-light text-blue-dark"
        :class="{ 'opacity-50': !selectedDeparture }"
        @mouseover="hover = true"
        @mouseleave="hover = false"
      >
        <!-- :disabled="!selectedDeparture" -->
        Book now
      </button>
      <div v-if="showPopUp" class="absolute bottom-12 left-0 right-0 mx-5 p-5 bg-white shadow-card rounded-lg border-black-0.1 pointer-events-none">
        <p class="text-center">Please select dates in order to book.</p>
      </div>
    </div>
  </div>
</template>

<script>
import DisplayPrice from './DisplayPrice.vue';
import SvgSprite from '../vendor/enso/components/SvgSprite.vue';
import { mapGetters } from 'vuex';
import DepartureSelection from './DepartureSelection.vue';

export default {
  components: {
    DisplayPrice,
    SvgSprite,
    DepartureSelection,
  },

  props: {
    adventureId: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      selectedDepartureId: null,
      hover: false,
    };
  },

  computed: {
    selectedDeparture() {
      return this.$store.state.departure.selectedDeparture;
    },

    enquireOnly() {
      if (this.$store.state.departure.selectedDeparture) {
        return this.$store.state.departure.selectedDeparture.enquire_only;
      } else {
        return this.$store.state.departure.adventure.enquire_only;
      }
    },

    showPopUp() {
      return !this.selectedDeparture && this.hover;
    },

    ...mapGetters('departure', ['priceGbp', 'priceUsd']),
  },

  created() {
    this.$store.dispatch('departure/GET_ADVENTURE_DATA', this.adventureId);
    // this.getUserBooking();
  },

  methods: {
    addonExtraIsChecked(uuid) {
      return (
        this.selectedAddonExtras.filter((extra) => {
          return extra.uuid === uuid;
        }).length > 0
      );
    },

    enquireNow() {
      this.$store.commit('modals/SET_SHOW_ENQUIRY_MODAL', true);
    },

    bookNow() {
      if (!this.selectedDeparture) {
        this.hover = true;
        setTimeout(() => {
          this.hover = false;
        }, 2000)
        return;
      }
      else {
        this.$store.commit('modals/SET_SHOW_BOOKING_MODAL', true);
      }
    },
  },
};
</script>
